// extracted by mini-css-extract-plugin
export default {"editorPageContainer":"EditorPage_editorPageContainer__6Ha2m"};